import { v4 as uuidv4 } from "uuid";

export const generateFilename = (fileType) => {
    return new Date().getTime() + "-" + uuidv4() + "." + fileType;
};
